import { render, staticRenderFns } from "./Package.vue?vue&type=template&id=954f956a&scoped=true"
import script from "./Package.vue?vue&type=script&lang=js"
export * from "./Package.vue?vue&type=script&lang=js"
import style0 from "./Package.vue?vue&type=style&index=0&id=954f956a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954f956a",
  null
  
)

export default component.exports